import { useState } from "react";
import { Copy } from "lucide-react";
import "../Styles/Dashboard.css";


import {  FiBarChart2,  FiUser,FiArrowDownRight } from "react-icons/fi";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import { useNavigate, useLocation } from "react-router-dom";
import { Link2 } from "lucide-react";
import { Outlet } from "react-router-dom";
// --- Individual Pages (Stripe-style sections) ---












export default function SidebarDashboard() {
  
const [menuOpen, setMenuOpen] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const business = useSelector((state) => state.auth.business);

const mainPages = [
  {
    name: "Business Profile",
    icon: <FiUser />,
    path: "/dashboard/profile",
  },
  {
    name: "Analytics",
    icon: <FiBarChart2 />,
    path: `/dashboard/Analytics`,
  },

  
  
  {
    name: "Referrals",
    icon: <Link2 />,
    path: `/dashboard/Referrals`,
  },
];

const navigate = useNavigate();
const location = useLocation();

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(business?.businessLink || "https://clusterclear.app");
    toast.success("Link copied to clipboard");
  };

  // if (user?.onboardingStage === "none") {
  //   window.location.href = "/onboarding-step-one";
  //   return null;
  // }

  // if (user?.onboardingStage === "step_two") {
  //   window.location.href = "/onboarding-step-two";
  //   return null;
  // }


return (
  <>
    {!business ? (
     <div className="demo-container">
    <div className="phone-wrapper">
      <div className="phone">
        <div className="phone-top" />

        {/* HEADER SKELETON */}
        <div className="customer-header">
          <div className="skeleton-avatar" />

          <div className="skeleton-line short" />
          <div className="skeleton-line long" />

          <div className="about-card">
            <div className="skeleton-line full" />
            <div className="skeleton-line full" />
          </div>
        </div>

        {/* BUTTONS SKELETON */}
        <div className="link-buttons">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="skeleton-button" />
          ))}
        </div>
      </div>
    </div>
  </div>
    ) : (
      <div className="layout">

        {/* MOBILE OVERLAY */}
        {menuOpen && (
          <div
            className="overlay"
            onClick={() => setMenuOpen(false)}
          />
        )}

        {/* SIDEBAR */}
        <aside className={`sidebar ${menuOpen ? "open" : ""}`}>

          <div className="sidebar-top">
            <div className="brand">Cluster Clear</div>

            <button className="copy-btn" onClick={copyLink}>
              <Copy size={16} /> Copy Link
            </button>
          </div>

          {/* MAIN NAV */}
          <div className="nav-section">
            <p className="nav-title">Overview</p>

            {mainPages.map((page) => (
              <button
                key={page.name}
                className={`nav-item ${
                  location.pathname === page.path ? "active" : ""
                }`}
                onClick={() => {
                  navigate(page.path);
                  setMenuOpen(false);
                }}
              >
                {page.icon}
                <span>{page.name}</span>
              </button>
            ))}
          </div>

          {/* FOOTER */}
          <div className="sidebar-footer">
            <div className="user-box">
              <FiUser />
              <span>{user?.email?.split("@")[0]}</span>
            </div>

            <button className="logout-btn" onClick={logout}>
              <FiArrowDownRight /> Logout
            </button>
          </div>
        </aside>

        {/* MAIN */}
        <main className="main">

          {/* MOBILE TOPBAR */}
          <div className="mobile-topbar">
            <button
              className="menu-btn"
              onClick={() => setMenuOpen(true)}
            >
              ☰
            </button>
          </div>

          <div className="page-wrapper">
            <Outlet />
          </div>

        </main>
      </div>
    )}
  </>
);

}
